//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { TRUSTPILOT_URL } from '~/const/3rd';
export default {
  name: 'TrustPilot',

  mounted() {
    this.asyncScript(TRUSTPILOT_URL).then(() => {}).catch(err => {
      this.$logger.error("TRUSTPILOT_URL FAILED ".concat(err));
    });
  }

};